import { render } from "./balkenMitBildVerpackungen.vue?vue&type=template&id=4d2a1f7b"
import script from "./balkenMitBildVerpackungen.vue?vue&type=script&lang=js"
export * from "./balkenMitBildVerpackungen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__